__turbopack_context__.v({
  "form": "calculator-module-scss-module__ZFW3Za__form",
  "headline": "calculator-module-scss-module__ZFW3Za__headline",
  "p2h": "calculator-module-scss-module__ZFW3Za__p2h",
  "placeholder": "calculator-module-scss-module__ZFW3Za__placeholder",
  "unit": "calculator-module-scss-module__ZFW3Za__unit",
});
